import React from 'react';
import { formatAddressForDisplay, formatCityState, addressStyles } from '../utils/addressFormatters';

const PropertyDetailsCard = ({ listing, onPropertyDetailsClick }) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow w-full">
      <div className="p-5">
        <div className="flex items-center mb-4">
          <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
            <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <h4 className="text-lg font-semibold text-gray-900">Property Details</h4>
        </div>
        
        <div className="space-y-3">
          <div className="flex justify-between items-start py-2 border-b border-gray-100">
            <span className="text-sm font-medium text-gray-600">Address</span>
            <span className={`${addressStyles.address} text-right break-words max-w-[70%]`}>
              {formatAddressForDisplay(listing.address)}
            </span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-gray-100">
            <span className="text-sm font-medium text-gray-600">City & State</span>
            <span className={`${addressStyles.cityState}`}>
              {formatCityState(listing.city, listing.state)}
            </span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-gray-100">
            <span className="text-sm font-medium text-gray-600">County</span>
            <span className="text-sm text-gray-900">{listing.county || 'N/A'}</span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-gray-100">
            <span className="text-sm font-medium text-gray-600">Defendant</span>
            <span className="text-sm text-gray-900 text-right max-w-xs truncate" title={listing.defendant || 'N/A'}>
              {listing.defendant || 'N/A'}
            </span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-gray-100">
            <span className="text-sm font-medium text-gray-600">Court Case #</span>
            <span className="text-sm text-gray-900 font-mono">{listing.court_case_no || 'N/A'}</span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-gray-100">
            <span className="text-sm font-medium text-gray-600">Sale Date</span>
            <span className={`text-sm font-medium ${listing.isAdjourned ? 'text-orange-600' : 'text-gray-900'}`}>
              {listing.sale_date || 'N/A'}
              {listing.isAdjourned && (
                <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                  Adjourned
                </span>
              )}
            </span>
          </div>
          
          {/* Property Record Link */}
          {listing.property_id && (
            <div className="pt-3 mt-3 border-t border-gray-100">
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  onPropertyDetailsClick(e, listing);
                }}
                className="w-full inline-flex items-center justify-center px-3 py-2 border border-blue-300 shadow-sm text-sm leading-4 font-medium rounded-md text-blue-700 bg-blue-50 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                View Official Record
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyDetailsCard;